import React, { useCallback, useState } from "react";
import { Link, useNavigate as reactUseNavigate, useLocation } from "react-router-dom";
import { AppstoreOutlined, HomeOutlined, ShoppingOutlined } from "@ant-design/icons";
// import { NavigationMenu } from "@shopify/app-bridge-react";
import { Menu } from "antd";
import { getNavigationLinks } from "@/Assets/Mocks/Navigation.mock";
import { localStorage } from "@/Utils/Index";

export const AppNavigationMenu = () => {
  const NavigationLinks = getNavigationLinks();
  if (process.env.ENV === "dev") {
    NavigationLinks.splice(2, 0, {
      label: "Backend Testing",
      destination: "/backendTesting",
    });
  }
  const handleActiveLink = (link, location) => {
    const params = new URLSearchParams(location.href);
    const activenavmenu = params.get("activenavmenu");
    let parentMenu = "";
    if (activenavmenu?.length > 0) {
      parentMenu = `/${activenavmenu}`;
      return link.destination === parentMenu;
    } else {
      return link.destination === location.pathname;
    }
  };

  const location = useLocation();
  const navigation = reactUseNavigate();
  const [selected, setSelected] = useState(location.pathname);

  const handleClick = useCallback((item) => {
    navigation(item.destination);
    setSelected(item.destination);
  }, []);

  if (!localStorage()?.getItem("adminAccessToken")) {
    return (
      <NavigationMenu
        navigationLinks={NavigationLinks}
        matcher={(link, location) => handleActiveLink(link, location)}
      />
    );
  }

  return (
    <Menu
      mode="inline"
      selectedKeys={[selected]}
      items={NavigationLinks.map((item) => ({
        key: item.destination,
        icon: <HomeOutlined />,
        label: item.label,
        onClick: () => handleClick(item),
      }))}
    />
  );
};

export const navigate = () => {
  let navigate;
  if (!localStorage()?.getItem("adminAccessToken")) {
    // navigate = shopifyUseNavigate();
  } else {
    navigate = reactUseNavigate();
  }
  return navigate;
};
